import { createSlice } from '@reduxjs/toolkit';

const profileSlice = createSlice({
  name: 'profile',
  initialState: {
    getParcelPassengerCitiesData: [],
    getParcelPassengerCitiesDataIsLoading: false,
    getParcelPassengerCitiesDataErrorMsg: null,

    updateProfileData: {},
    updateProfileDataIsLoading: false,
    updateProfileDataErrorMsg: null,
  },
  reducers: {
    getParcelPassengerCitiesReq: (state, action) => { },
    getParcelPassengerCitiesSuccess: (state, action) => ({
      ...state,
      getParcelPassengerCitiesData: action.payload,
      getParcelPassengerCitiesDataIsLoading: false,
      getParcelPassengerCitiesDataErrorMsg: null,
    }),
    getParcelPassengerCitiesFailure: (state, action) => ({
      ...state,
      getParcelPassengerCitiesDataIsLoading: false,
      getParcelPassengerCitiesDataErrorMsg: action.payload,
    }),
    getParcelPassengerCitiesLoading: (state) => ({
      ...state,
      getParcelPassengerCitiesDataIsLoading: true,
      getParcelPassengerCitiesDataErrorMsg: null,
    }),
    getParcelPassengerCitiesClear: (state) => ({
      ...state,
      getParcelPassengerCitiesData: [],
      getParcelPassengerCitiesDataIsLoading: false,
      getParcelPassengerCitiesDataErrorMsg: null,
    }),

    // Update Profile
    updateProfileReq: (state, action) => { },
    updateProfileSuccess: (state, action) => ({
      ...state,
      updateProfileData: action.payload,
      updateProfileDataIsLoading: false,
      updateProfileDataErrorMsg: null,
    }),
    updateProfileFailure: (state, action) => ({
      ...state,
      updateProfileDataIsLoading: false,
      updateProfileDataErrorMsg: action.payload,
    }),
    updateProfileLoading: (state) => ({
      ...state,
      updateProfileDataIsLoading: true,
      updateProfileDataErrorMsg: null,
    }),
    updateProfileClear: (state) => ({
      ...state,
      updateProfileData: {},
      updateProfileDataIsLoading: false,
      updateProfileDataErrorMsg: null,
    }),
  },
});

export const {
  getParcelPassengerCitiesClear,
  getParcelPassengerCitiesFailure,
  getParcelPassengerCitiesLoading,
  getParcelPassengerCitiesReq,
  getParcelPassengerCitiesSuccess,

  updateProfileClear,
  updateProfileFailure,
  updateProfileLoading,
  updateProfileReq,
  updateProfileSuccess,
} = profileSlice.actions;

export default profileSlice.reducer;
